import { gql } from '@apollo/client'

export const GET_BOOKINGS_DASHBOARD = gql`
    query GetBookingsDashboard($period: REVENUE_PERIOD, $dateRange: DateRangeInput, $routeType: RouteType) {
        getBookingsDashboard(period: $period, date_range: $dateRange, route_type: $routeType) {
            code
            success
            message
            bookings_dashboard {
                total_bookings
                completed_bookings
                ontrip_bookings
                noshow_bookings
                cancelled_bookings
                trip_cancelled_bookings
                confirmed_bookings
                total_std_bookings
                completed_std_bookings
                cancelled_std_bookings
                trip_cancelled_std_bookings
                total_daypass_bookings
                total_daypass_std_bookings
                cancelled_daypass_std_bookings
                completed_daypass_std_bookings
                total_passengers
                std_passengers_completed
                std_passengers_cancelled
                daypass_passengers_completed
                daypass_passengers_cancelled
                total_chartered_boat_bookings
                under_review_chartered_boat_bookings
                approved_chartered_boat_bookings
                confirmed_chartered_boat_bookings
                completed_chartered_boat_bookings
                cancelled_chartered_boat_bookings
                trip_cancelled_chartered_boat_bookings
                charter_boat_passengers_completed
                charter_boat_passengers_cancelled
                ticket_class_distribution {
                    period_label
                    vip_seat_count
                    std_seat_count
                }
                fleet_availability {
                    boat_status {
                        en
                        ar
                    }
                    boat_count
                    avl_percentage
                    total_count
                }
                passenger_demographics {
                    infant_percentage
                    child_percentage
                    adult_percentage
                    senior_percentage
                    total_passengers
                }
                hourly_booking_trends {
                    booking_hour
                    booking_hour_label
                    booking_count
                }
                top_routes_by_bookings {
                    master_route_id
                    route_name {
                        en
                        ar
                    }
                    pass_count
                }
                route_performance_summary {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    start_time
                    end_time
                    cmp_count
                    can_count
                }
                check_in_out_trends {
                    station_id
                    station_name {
                        en
                        ar
                    }
                    checkin_count
                    checkout_count
                }
            }
        }
    }
`
